import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { AppLayout } from '@/components/AppLayout'
import { isAuthenticated } from '@/lib/auth-store'

export const Route = createFileRoute('/urls')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' })
    }
  },
  component: UrlsLayout,
})

function UrlsLayout() {
  return (
    <AppLayout title="Tracked URLs">
      <Outlet />
    </AppLayout>
  )
}
